var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCmp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide:chart-no-axes-combined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99996 13.3333V17.5M13.3333 11.6667V17.5M16.6666 8.33333V17.5M18.3333 2.5L11.1283 9.705C11.0896 9.7438 11.0436 9.77459 10.993 9.79559C10.9424 9.8166 10.8881 9.82741 10.8333 9.82741C10.7785 9.82741 10.7242 9.8166 10.6736 9.79559C10.623 9.77459 10.577 9.7438 10.5383 9.705L7.79496 6.96167C7.71682 6.88355 7.61086 6.83967 7.50038 6.83967C7.38989 6.83967 7.28393 6.88355 7.20579 6.96167L1.66663 12.5M3.33329 15V17.5M6.66663 11.6667V17.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCmp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cmp.0f2e7362.svg";
export { ForwardRef as ReactComponent };